export { default } from './IconLock';
